export const strings = {
  articles: 'Makaleler',
  publish: 'Yayınlamak',
  like: 'Beğendim',
  src: 'Kaynak',
  speciality_placeholder: 'Uzmanlık Seçin',
  all_article: 'Tüm Makaleler',
  all_specialities: 'Tüm Uzmanlık Alanları',
  my_article: 'Makalelerim',
  see_all_articles: 'Tüm {num} Makalelerini Gör',
  saved_article: 'Kayıtlı Makaleler',
  have_not_written_article: 'Henüz hiç Makale yazmadınız mı?',
  write_article: 'Bir makale yaz',
  new_article: 'Yeni Makale',
  save_as_draft: 'Taslak Olarak Kaydet',
  articles_by: '{name} Tarafından Makaleler',
  cover_image: 'Kapak Resmi',
  article_title: 'Makale Adı',
  brief: 'Özet',
  optional: 'Opsiyonel',
  tags: 'Etiketler (Size alakalı arama sonuçlarını göstermemize yardımcı olmak için etiketler ekleyin)',
  add_mention: 'Bahsetme Ekle',
  source: 'Kaynak',
  search_placeholder: 'Makaleleri Ara',
  title_placeholder: 'Başlık girin',
  brief_placeholder: 'Buraya yazın...',
  tags_placeholder: 'Etiket ekleme',
  source_placeholder: 'URL bağlantısını buraya yapıştırın',
  time_taken: 'Okumak İçin Geçen Süre',
  time_placeholder: 'Zamanı dakika cinsinden girin',
  speciality: 'Özel',
  add_tag: 'Etiket Ekle',
  mentions: 'Bahsetmeler',
  mention_people: "Bahsedilen SMM'ler:",
  errors: {
    cover_required: 'Makale kapak resmi yüklemeniz gerekiyor',
    title_required: 'Makale Başlığı gereklidir',
    title_min_length: 'Makale başlığı en az 3 karakter olmalıdır',
    title_max_length: 'Makale başlığı 250 karakterden fazla olamaz',
    brief_required: 'Makale Özeti gereklidir',
    brief_min_length: 'Makale Özeti en az 3 karakter olmalıdır',
    brief_max_length: 'Makale Özeti 250 karakterden fazla olamaz',
    duration_number: 'Zaman her zaman bir sayı olmalıdır',
    duration_min: 'Zaman sıfırdan büyük olmalıdır',
    duration_max: "Zaman 1000'den büyük olmamalıdır",
    duration_negative: 'Zaman pozitif tamsayı olmalıdır',
    source_url: 'Kaynak geçerli bir URL olmalıdır',
    source_max_limit: 'Kaynak 300 karakterden fazla olamaz',
    description_required: 'Makale açıklaması gereklidir',
    description_min_length: 'Makale açıklaması en az 3 karakter olmalıdır',
    description_max_length: 'Makale açıklaması 2500 karakterden fazla olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
    cover_uploading: 'Kapak yükleniyor',
    age_max: "Yaş 125'ten büyük olmamalıdır",
  },
  time_to_read: '{zaman} minumum okuma',
  published_ago: 'Yayınlanma {tarihi}',
  edit_article: 'Makaleyi Düzenle',
  edit_draft: 'Taslağı Düzenle',
  delete_draft: 'Taslağı Sil',
  discard_changes: 'Değişiklikleri At',
  delete_article: 'Makaleyi Sil',
  draft: 'Taslak',
  published: 'Yayımlanmış',
  published_on: 'Yayınlandı {date}',
  edit: 'Düzenlemek',
  cancel: 'İptal',
  delete_changes_confirmation: 'Taslağı silmek istediğinizden emin misiniz?',
  saving_changes_confirmation:
    'Değişiklikleri kaydetmeden geri dönmek istediğinizden emin misiniz?',
  saving_changes_confirmation_desc:
    'Kaydedilmemiş değişiklikleriniz var. Son yapılan tüm değişiklikleri kaybedersiniz ve bu işlem geri alınamaz',
  last_updated: 'En son {date} tarihinde güncellendi',
  no_blog: 'Blog Yok',
};
